module.exports = __webpack_public_path__ + "static/media/covid19.c980247d.png";